import { ESSENTIALS_IMG } from './media';

/* All page copy lives here so it can be edited without touching layout. */

/* Every "Get in touch" call to action points at the ClickUp intake form.
   The email address stays as an alternative route in the footer. */
export const CONTACT_EMAIL = 'natalya@vitalityvf.com';
export const CONTACT_HREF =
  'https://forms.clickup.com/9013492263/f/8ckxyh7-6653/VEIG11FRLDONDZ4GJ9';

export const ESSENTIALS = [
  {
    name: 'Air',
    line: 'How we breathe.',
    text: 'Cleaner air and a healthier atmosphere.',
    img: ESSENTIALS_IMG.air,
    alt: 'Clouds in an open sky',
  },
  {
    name: 'Water',
    line: 'How life flows.',
    text: 'Better ways to access, purify, conserve and restore water.',
    img: ESSENTIALS_IMG.water,
    alt: 'Ocean surface',
  },
  {
    name: 'Food',
    line: 'How we nourish.',
    text: 'Food systems that nourish people while regenerating the planet.',
    img: ESSENTIALS_IMG.food,
    alt: 'Cultivated green field',
  },
  {
    name: 'Health',
    line: 'How we thrive.',
    text: 'New ways to prevent, heal and live better by learning from living systems.',
    img: ESSENTIALS_IMG.health,
    alt: 'Dew on a leaf',
  },
  {
    name: 'Materials',
    line: 'How we make.',
    text: 'Better ways to build, wear, package and create, inspired by nature.',
    img: ESSENTIALS_IMG.materials,
    alt: 'Natural woven material texture',
  },
];

export const AUDIENCE_CARDS = [
  {
    id: 'founders',
    eyebrow: 'For founders',
    title: 'Building from nature?',
    body: 'We want to know what you are working on. Get access to mentors, pilots, partners, capital and a community that helps you go further.',
  },
  {
    id: 'mentors',
    eyebrow: 'For mentors',
    title: 'Help a breakthrough move faster.',
    body: 'Share your experience, open doors and make a real impact.',
  },
  {
    id: 'partners',
    eyebrow: 'For partners',
    title: 'Be the first to say yes.',
    body: 'Bring us your challenges. We will connect you with emerging innovations that can solve real-world problems.',
  },
];
